export default "__VITE_ASSET__DoTkZLE6__"